import React, { useState, useEffect } from 'react';

const initData = {
    heading: "Şehrin Sosyal Rehberi",
    content: "Canlı müzik, workshop'lar, söyleşiler ve daha fazlası artık tek bir yerde. Instagram'da kaybolan etkinlikleri aramakla vakit kaybetme, ilgi alanlarına göre öneriler al ve favori organizatörleri takip et. Kaçırmak istemediğin etkinlikleri kolayca bul, şehirde olup bitenlerden her zaman haberdar ol!",
    headingSlug: "* Hemen indir Keşfetmeye başla!",
    playImg: "/img/google-play.png",
    appleImg: "/img/app-store.png",
    heroThumb: "/img/Home.png"
};

const HeroSection = () => {
    const [data, setData] = useState({});

    useEffect(() => {
        setData(initData);
    }, []);

    return (
        <section 
            id="home" 
            className="section welcome-area overflow-hidden d-flex align-items-center"
            style={{ 
                background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                color: 'white'
            }}
        >
            <div className="container">
                <div className="row align-items-center">
                    {/* Welcome Intro Start */}
                    <div className="col-12 col-md-7 col-lg-6">
                        <div className="welcome-intro">
                            <h1 className="text-white">{data.heading}</h1>
                            <p className="text-white my-4">{data.content}</p>
                            {/* Store Buttons */}
                            <div className="button-group store-buttons d-flex">
                                <a href="/download-page">
                                    <img src={data.playImg} alt="Google Play" />
                                </a>
                                <a href="/download-page">
                                    <img src={data.appleImg} alt="App Store" />
                                </a>
                            </div>
                            <span className="d-inline-block text-white fw-3 font-italic mt-3">{data.headingSlug}</span>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 col-lg-6">
                        {/* Welcome Thumb */}
                        <div className="welcome-thumb mx-auto" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                            <img src={data.heroThumb} alt="App Mockup" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="shape-bottom">
                <svg viewBox="0 0 1920 310" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="svg replaced-svg">
                    <title>sApp Shape</title>
                    <desc>Created with Sketch</desc>
                    <defs />
                    <g id="sApp-Landing-Page" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                        <g id="sApp-v1.0" transform="translate(0.000000, -554.000000)" fill="#FFFFFF">
                            <path d="M-3,551 C186.257589,757.321118 319.044414,856.322454 395.360475,848.004007 C509.834566,835.526337 561.525143,796.329212 637.731734,765.961549 C713.938325,735.593886 816.980646,681.910577 1035.72208,733.065469 C1254.46351,784.220361 1511.54925,678.92359 1539.40808,662.398665 C1567.2669,645.87374 1660.9143,591.478574 1773.19378,597.641868 C1848.04677,601.75073 1901.75645,588.357675 1934.32284,557.462704 L1934.32284,863.183395 L-3,863.183395" id="sApp-v1.0" />
                        </g>
                    </g>
                </svg>
            </div>
        </section>
    );
}

export default HeroSection;